import { Box, Card, Typography, useTheme } from "@mui/material";
import React from "react";

const FilterCard = ({ title, description, badge, meta, children }) => {
  const theme = useTheme();

  return (
    <Card
      elevation={0}
      sx={{
        height: "100%",
        p: 2.5,
        border: `1px solid ${theme.palette.border.main}`,
        borderRadius: "8px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 1,
        }}
      >
        <Typography variant="h6" sx={{ fontSize: "1rem", fontWeight: 600 }}>
          {title}
        </Typography>
        {badge ??
          (meta && (
            <Typography
              variant="caption"
              sx={{ color: theme.palette.lightText.main }}
            >
              {meta}
            </Typography>
          ))}
      </Box>
      {description && (
        <Typography
          variant="body2"
          sx={{ color: theme.palette.lightText.main, mt: 0.5 }}
        >
          {description}
        </Typography>
      )}
      <Box sx={{ mt: 2 }}>{children}</Box>
    </Card>
  );
};

export default FilterCard;
